var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTenantMgt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.288 9.838c.238 0 .434.194.434.435h0v7.784a.435.435 0 01-.434.434h0H3.984a.435.435 0 01-.434-.434h0v-7.683a.435.435 0 01.869 0h0v7.245h11.435v-7.346c0-.238.193-.435.434-.435zm-8.446-.247c.828 0 1.548.563 1.741 1.37h0l.014.062h4.265c.2 0 .36.162.36.36h0v1.682c0 .2-.163.36-.36.36a.343.343 0 01-.346-.356h0v-1.324h-1.578v1.324a.36.36 0 01-.72 0h0v-1.324H9.282a.36.36 0 01-.36-.36 1.076 1.076 0 10-.797 1.039.356.356 0 11.183.689 1.794 1.794 0 01-2.256-1.73c0-.988.804-1.792 1.791-1.792zm2.372-8.1c.119 0 .234.048.316.132h0l8.222 8.222a.444.444 0 010 .631.444.444 0 01-.632 0h0L10.214 2.57l-7.906 7.906a.444.444 0 01-.631 0 .449.449 0 010-.63h0l8.222-8.223a.444.444 0 01.315-.132z",
    stroke: "#currentColor",
    strokeWidth: 0.5,
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenantMgt);
export default __webpack_public_path__ + "static/assets/tenantMgt.6ccd3570.svg";
export { ForwardRef as ReactComponent };